/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UnresolvedVendorErrorCodeResponseDto } from './UnresolvedVendorErrorCodeResponseDto';
import {
    UnresolvedVendorErrorCodeResponseDtoFromJSON,
    UnresolvedVendorErrorCodeResponseDtoFromJSONTyped,
    UnresolvedVendorErrorCodeResponseDtoToJSON,
    UnresolvedVendorErrorCodeResponseDtoToJSONTyped,
} from './UnresolvedVendorErrorCodeResponseDto';
import type { PaginationMetaDto } from './PaginationMetaDto';
import {
    PaginationMetaDtoFromJSON,
    PaginationMetaDtoFromJSONTyped,
    PaginationMetaDtoToJSON,
    PaginationMetaDtoToJSONTyped,
} from './PaginationMetaDto';

/**
 * 
 * @export
 * @interface ListUnresolvedVendorErrorCodesResponseDto
 */
export interface ListUnresolvedVendorErrorCodesResponseDto {
    /**
     * 
     * @type {Array<UnresolvedVendorErrorCodeResponseDto>}
     * @memberof ListUnresolvedVendorErrorCodesResponseDto
     */
    data: Array<UnresolvedVendorErrorCodeResponseDto>;
    /**
     * 
     * @type {PaginationMetaDto}
     * @memberof ListUnresolvedVendorErrorCodesResponseDto
     */
    meta: PaginationMetaDto;
}

/**
 * Check if a given object implements the ListUnresolvedVendorErrorCodesResponseDto interface.
 */
export function instanceOfListUnresolvedVendorErrorCodesResponseDto(value: object): value is ListUnresolvedVendorErrorCodesResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ListUnresolvedVendorErrorCodesResponseDtoFromJSON(json: any): ListUnresolvedVendorErrorCodesResponseDto {
    return ListUnresolvedVendorErrorCodesResponseDtoFromJSONTyped(json, false);
}

export function ListUnresolvedVendorErrorCodesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListUnresolvedVendorErrorCodesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(UnresolvedVendorErrorCodeResponseDtoFromJSON)),
        'meta': PaginationMetaDtoFromJSON(json['meta']),
    };
}

export function ListUnresolvedVendorErrorCodesResponseDtoToJSON(json: any): ListUnresolvedVendorErrorCodesResponseDto {
    return ListUnresolvedVendorErrorCodesResponseDtoToJSONTyped(json, false);
}

export function ListUnresolvedVendorErrorCodesResponseDtoToJSONTyped(value?: ListUnresolvedVendorErrorCodesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(UnresolvedVendorErrorCodeResponseDtoToJSON)),
        'meta': PaginationMetaDtoToJSON(value['meta']),
    };
}

